import _ from 'lodash'
import Backbone from 'backbone'
import FormView from 'scoreboard/components/form-view'
import GroupForm from './group-form'
import i18n from 'scoreboard/components/i18n'
import template from './group-dialog.hbs'

const GroupDialog = Backbone.View.extend({

	tagName: 'form',

	className: 'group-dialog',

	initialize: function(options) {
		this.options = options || {}
	},

	render: function() {
		this.$el.empty().append(template({
			headerLabel: i18n.get(this.model.isNew() ? 'admin.group.add' : 'admin.group.edit')
		}))

		this.groupForm = new GroupForm({model: this.model}).render()
		this.$('.dialog-body-content').append(this.groupForm.el)

		this.formView = new FormView({
			el: this.el,
			submit: this.submit.bind(this)
		})
		this.groupForm.on('change', this.formView.change.bind(this.formView))
		this.formView.start()

		return this
	},

	submit: function() {
		const event = this.model.isNew() ? 'add' : 'edit'
		return this.model.save(this.groupForm.readFromDom(), {
			success: () => {
				Backbone.trigger(event + ':domain-object', this.model)
				this.groupForm.doneSaving()
				this.trigger('done')
			},
			error: (model, xhr) => this.formView.error(xhr)
		})
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.formView, this.groupForm], 'remove')
	}
})

export default GroupDialog

GroupDialog.__filename__ = 'admin/principals/groups/group-dialog.js'
